export enum PlatformsEnum {
    Desktop = "web",
    Android = "android",
    iOS = "ios",
}
